<template>
  <b-modal
    :id="modalId"
    ref="modalDelete"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    body-class="p-0"
    dialog-class="custom-width-modal"
  >
    <div class="komed-modal-container">
      <!-- Icon -->
      <div class="komed-modal-icon-wrapper">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
          alt="warning"
          width="120px"
        >
      </div>

      <!-- Text -->
      <h4 class="komed-modal-title">
        Hapus Konten
      </h4>
      <p
        class="komed-modal-subtitle"
        v-html="subtitleText"
      />

      <!-- Actions -->
      <div class="komed-modal-actions">
        <button
          class="komed-btn-cancel"
          @click="handleClose"
        >
          Batal
        </button>
        <button
          class="komed-btn-delete"
          :disabled="isLoading"
          @click="handleDelete"
        >
          <b-spinner
            v-if="isLoading"
            small
            class="mr-2"
          />
          <span v-if="isLoading">Menghapus...</span>
          <span v-else>Hapus Konten</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'

export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
    video: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    subtitleText() {
      if (!this.video) return ''

      if (this.video.isBulk) {
        if (this.video.isCheckAll) {
          return '<strong style="font-weight: 600; color: #0A0A0A;">Semua konten</strong> yang dipilih akan dihapus secara permanen dan tidak dapat dikembalikan. Yakin ingin menghapus konten ini?'
        }
        return `<strong style="font-weight: 600; color: #0A0A0A;">${this.video.selectedIds ? this.video.selectedIds.length : 0} konten</strong> yang dipilih akan dihapus secara permanen dan tidak dapat dikembalikan. Yakin ingin menghapus konten ini?`
      }
      return '<strong style="font-weight: 600; color: #0A0A0A;">1 konten</strong> yang dipilih akan dihapus secara permanen dan tidak dapat dikembalikan. Yakin ingin menghapus konten ini?'
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modalId)
      this.$emit('close')
    },
    async handleDelete() {
      if (!this.video) return

      this.isLoading = true
      try {
        if (this.video.isBulk) {
          await newAxiosIns.delete('/komed/api/v1/komed/content/bulk', {
            data: {
              ids: this.video.selectedIds,
              is_all: this.video.isCheckAll,
            },
          })
        } else {
          if (!this.video.id) return
          await newAxiosIns.delete(`/komed/api/v1/komed/content/${this.video.id}`)
        }
        this.$emit('success')
        this.handleClose()
      } catch (error) {
        this.$toast_error({
          message: error?.response?.data?.message || 'Gagal menghapus konten.',
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
::v-deep .custom-width-modal .modal-dialog {
  max-width: 420px;
  border-radius: 20px;
}
::v-deep .custom-width-modal .modal-content {
  border-radius: 20px;
  border: none;
}
.komed-modal-container {
  background: white;
  border-radius: 20px;
  padding: 28px 24px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.komed-modal-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.komed-modal-title {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  color: #0A0A0A;
  margin-bottom: 8px;
  margin-top: 0;
}
.komed-modal-subtitle {
  text-align: center;
  color: #525252;
  font-size: 14px;
  margin-bottom: 24px;
  margin-top: 0;
  line-height: 1.5;
}
.komed-modal-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  width: 100%;
  margin-top: 8px;
}
.komed-btn-cancel {
  width: 100%;
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid #E5E5E5;
  background: white;
  color: #262626;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.2s;
  outline: none;
}
.komed-btn-cancel:hover {
  background-color: #f8fafc;
}
.komed-btn-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.komed-btn-delete {
  width: 100%;
  padding: 10px 16px;
  border-radius: 12px;
  background: #F95E16;
  color: white;
  border: none;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.2s;
  outline: none;
}
.komed-btn-delete:hover {
  background-color: #e04f0d;
}
.komed-btn-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
